import { render, staticRenderFns } from "./CustomFieldList.vue?vue&type=template&id=68638413&scoped=true&"
import script from "./CustomFieldList.vue?vue&type=script&lang=js&"
export * from "./CustomFieldList.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldList.vue?vue&type=style&index=0&id=68638413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68638413",
  null
  
)

export default component.exports